export default "__VITE_ASSET__DG03UXl___"